import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import TrainingSchedule from '@/models/TrainingSchedule.js'

export const useTrainingScheduleStore = defineStore('trainingScheduleStore', () => {
  let syncableModel = useSyncableModel(useApiResource('training_schedules'), {
    className: TrainingSchedule.modelName.name,
    paramKey: TrainingSchedule.modelName.paramKey
  })

  function findByTrainingCourseUuid(uuid) {
    let item = syncableModel.collection.value.find((e) => e.training_course_uuid === uuid)
    item ??= { training_course_uuid: uuid }
    return item
  }

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    findByTrainingCourseUuid,
    $reset
  }

}, {
  persist: true
})